import React, { useEffect, useState, useRef } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import tableToExcel from '../../excel-downloads/tableToExcel';



const handleDownloadEx = () => {
  tableToExcel('SucessReport', 'My Worksheet');
};

const KeyRegisterAllotFPS_data = async (params) => {
  console.log(JSON.stringify(params));
  try {
    const response = await fetch(`${process.env.REACT_APP_URL_SALE}/NFSA_Date_Sale`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(params),
    });

    if (!response.ok) {
      throw new Error('Failed to fetch data');
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Data Fetch Error");
      }
};


const NFSA_Date_Sale = ({ dist_month, dist_year, trans_moth, trans_year }) => {

  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tabHeading, setTabHeading] = useState(null);
  const [dataDate, setDateDate] = useState("");
  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      try {
        console.log("Fetching Data with Params:", { dist_month, dist_year, trans_moth, trans_year });

        const response_data = await KeyRegisterAllotFPS_data({
          dist_month,
          dist_year,
          trans_moth,
          trans_year,
        });

        if (response_data.data && Array.isArray(response_data.data)) {
          const processedData = response_data.data.map(item => ({
            ...item,
            lst: Array.isArray(item.lst) ? item.lst : [],
          }));
          setReportData(processedData);
          setTabHeading(response_data.heading);

        } else {

          setReportData([]);
        }
      } catch (err) {
        console.error("Data Fetch Error:", err.message);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    getData();
  }, [dist_month, dist_year, trans_moth, trans_year]);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Box sx={{ display: 'flex' }}>
          <CircularProgress/>
        </Box>
      </div>
    );
  }

  if (error) {
    return <div className="mainhead" align="center">
    Internal Error
    </div>
  }

  if (reportData.length === 0) {
    return <div className="mainhead" align="center">
No data found 
</div>
  } 
  const totals = reportData.reduce(
    (acc, item) => {
      acc.total_nfsa_rice += parseFloat(item.nfsa_rice ) || 0.0;
      acc.total_nfsa_frice += parseFloat(item.nfsa_frice ) || 0.0;
      acc.total_nfsa_wheat += parseFloat(item.nfsa_wheat ) || 0.0;
      acc.total_nfsa_atta += parseFloat(item.nfsa_atta ) || 0.0;
      acc.total_pmgkay_rice += parseFloat(item.pmgkay_rice ) || 0.0;
      acc.total_pmgkay_wheat += parseFloat(item.pmgkay_wheat ) || 0.0;
      acc.total_pmgkay_dal += parseFloat(item.pmgkay_dal ) || 0.0;

      return acc;
    },
    {
      total_nfsa_rice: 0,
      total_nfsa_frice: 0,
      total_nfsa_wheat: 0,
      total_nfsa_atta: 0,
      total_pmgkay_rice: 0,
      total_pmgkay_wheat: 0,
      total_pmgkay_dal: 0

    }
  );


  return (
    <>

      <table /*ref={fpscardstab}*/ align="center" width="90%" border={1} id="SucessReport">
        <thead>
          <tr className="tableheader">
            <td colSpan={9}> {tabHeading}

            </td>
          </tr>
          <tr className="tableheader">
            <td>Distribution<br></br>Date</td>
            <td>Rice</td>
            <td>FRice</td>
            <td>Wheat</td>
            <td>Atta</td>
            <td>PMGKAY<br />Rice</td>
            <td>PMGKAY<br />Wheat</td>
            <td>PMGKAY<br />Dal</td>
          </tr>

        </thead>
        <tbody>
          {reportData.map((item, index) => (


            <>
              <tr key={item.fps_id}>


                <td style={{ textAlign: 'center' }}>
                  {new Date(item.logindatetime).toLocaleDateString('en-GB').replace(/\//g, '-')}
                </td>
                <td style={{ textAlign: 'right' }}>{item.nfsa_rice.toFixed(3) }</td>
                <td style={{ textAlign: 'right' }}>{item.nfsa_frice.toFixed(3) }</td>
                <td style={{ textAlign: 'right' }}>{item.nfsa_wheat.toFixed(3) }</td>
                <td style={{ textAlign: 'right' }}>  {item.nfsa_atta.toFixed(3) }</td>
                <td style={{ textAlign: 'right' }}>  {item.pmgkay_rice.toFixed(3) }</td>
                <td style={{ textAlign: 'right' }}>  {item.pmgkay_wheat.toFixed(3) }</td>
                <td style={{ textAlign: 'right' }}>  {item.pmgkay_dal.toFixed(3) }</td>

                {item.lst && Array.isArray(item.lst) && item.lst.map((item1, idx) => (
                  <td key={idx} style={{ textAlign: 'right' }}>{item1.availed_qty}</td>
                ))}
              </tr>

            </>
          ))}

          <tr className="tableheader">
            <td style={{ textAlign: 'center', fontWeight: 'bold' }}>Total:</td>
            <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.total_nfsa_rice.toFixed(3)}</td>
            <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.total_nfsa_frice.toFixed(3)}</td>
            <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.total_nfsa_wheat.toFixed(3)}</td>
            <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.total_nfsa_atta.toFixed(3)}</td>
            <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.total_pmgkay_rice.toFixed(3)}</td>
            <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.total_pmgkay_wheat.toFixed(3)}</td>
            <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.total_pmgkay_dal.toFixed(3)}</td>
          </tr>
          <tr style={{ textAlign: 'right' }}>
            <td colSpan="9">
              <span style={{ color: 'red' }}>Refresh Time: </span>
              <span style={{ color: 'green' }}>{ reportData[0].data_time}</span>
            </td>
          </tr>

        </tbody>


      </table> <br></br>
      <div align="center"><button type="button" class="button button2" onClick={handleDownloadEx}>Export to Excel</button>
      </div>

    </>
  );
};

export default NFSA_Date_Sale;
